import Image from 'next/image'

import { Sentiment } from '@types'

import Button from '@components/buttons/button/button'

import SmileySad from './smiley-sad.svg'
import Smiley from './smiley.svg'
import TickCircle from './tick-circle.svg'

import styles from './sentiment-tracker-button.module.scss'

type SentimentTrackerButtonProps = {
  variant: Sentiment
  onClick: () => void
  clicked: boolean
}

export default function SentimentTrackerButton({
  variant,
  onClick,
  clicked,
}: SentimentTrackerButtonProps): JSX.Element {
  return (
    <Button className={`${styles.button} ${styles[variant.toLowerCase()]}`} onClick={onClick}>
      {clicked && <Image src={TickCircle} alt="tick circle" />}
      {!clicked && variant === 'GOOD' && <Image src={Smiley} alt="smiley" width={46} height={46} />}
      {!clicked && variant === 'BAD' && <Image src={SmileySad} alt="sad smiley" width={46} height={46} />}
    </Button>
  )
}
